/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import { useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import { authAPI } from '../api/auth';

const ACCENT = '#3B82F6';

export default function VerificaEmail() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const avviato = useRef(false);

  const verificaMut = useMutation({ mutationFn: () => authAPI.verifyEmail(token) });

  useEffect(() => {
    if (token && !avviato.current) {
      avviato.current = true;
      verificaMut.mutate();
    }
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  let contenuto;
  if (!token) {
    contenuto = (
      <>
        <div style={{ ...styles.iconCircle, backgroundColor: '#FEE2E2' }}><XCircle size={30} color="#DC2626" /></div>
        <h1 style={styles.title}>Link non valido</h1>
        <p style={styles.subtitle}>Il link di verifica è incompleto o mancante.</p>
        <Link to="/login" style={styles.btn}>Vai al login</Link>
      </>
    );
  } else if (verificaMut.isPending || verificaMut.isIdle) {
    contenuto = (
      <>
        <div style={styles.iconCircle}><Loader size={30} color={ACCENT} /></div>
        <h1 style={styles.title}>Verifica in corso...</h1>
        <p style={styles.subtitle}>Stiamo attivando il tuo account.</p>
      </>
    );
  } else if (verificaMut.isSuccess) {
    contenuto = (
      <>
        <div style={{ ...styles.iconCircle, backgroundColor: '#D1FAE5' }}><CheckCircle size={30} color="#059669" /></div>
        <h1 style={styles.title}>Email verificata!</h1>
        <p style={styles.subtitle}>Il tuo account è attivo. Ora puoi accedere.</p>
        <Link to="/login" style={styles.btn}>Accedi</Link>
      </>
    );
  } else {
    contenuto = (
      <>
        <div style={{ ...styles.iconCircle, backgroundColor: '#FEE2E2' }}><XCircle size={30} color="#DC2626" /></div>
        <h1 style={styles.title}>Verifica non riuscita</h1>
        <p style={styles.subtitle}>
          {verificaMut.error?.response?.data?.error || 'Il link è scaduto o non valido. Richiedine uno nuovo dal login.'}
        </p>
        <Link to="/login" style={styles.btn}>Vai al login</Link>
      </>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>{contenuto}</div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F3F4F6', padding: '1rem' },
  card: { backgroundColor: 'white', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', width: '100%', maxWidth: '420px', textAlign: 'center' },
  iconCircle: { width: '64px', height: '64px', borderRadius: '50%', backgroundColor: ACCENT + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem' },
  title: { fontSize: '1.5rem', fontWeight: 700, margin: 0, color: '#111827' },
  subtitle: { color: '#6B7280', marginTop: '0.5rem', marginBottom: '1.5rem', lineHeight: 1.5 },
  btn: { display: 'inline-block', padding: '0.75rem 1.5rem', backgroundColor: ACCENT, color: 'white', textDecoration: 'none', borderRadius: '8px', fontWeight: 600 },
};
